__turbopack_context__.v({
  "decoration": "CosmeticSelect-module-scss-module__ogKbpG__decoration",
  "noContent": "CosmeticSelect-module-scss-module__ogKbpG__noContent",
  "noContentNoUrl": "CosmeticSelect-module-scss-module__ogKbpG__noContentNoUrl",
  "selected": "CosmeticSelect-module-scss-module__ogKbpG__selected",
});
